import { render, staticRenderFns } from "./AssignedTestsListPublic.vue?vue&type=template&id=28e4717c&"
import script from "./AssignedTestsListPublic.vue?vue&type=script&lang=js&"
export * from "./AssignedTestsListPublic.vue?vue&type=script&lang=js&"
import style0 from "./AssignedTestsListPublic.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports